import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';

interface FastRegistrationHaveAccountProps {
    hasAccount: boolean;
    onClick: () => void;
}

export default class FastRegistrationHaveAccount extends PureComponent<FastRegistrationHaveAccountProps> {
    render(): ReactNode {
        const {hasAccount, onClick} = this.props;

        return <>
            {hasAccount &&
                <div className="registration-have-account">
                    <span className="registration-have-account__title">{I18n.t('have_account')}</span>
                    <button
                        className="registration-have-account__button"
                        onClick={onClick}
                    >
                        {I18n.t('login_button')}
                    </button>
                </div>
            }
            {!hasAccount &&
                <div className="registration-have-account">
                    <span className="registration-have-account__title">{I18n.t('have_not_account')}</span>
                    <button
                        className="registration-have-account__button"
                        onClick={onClick}
                    >
                        {I18n.t('chek_up')}
                    </button>
                </div>
            }
        </>;
    }
}
